import React from 'react';

const Textarea = ({
  label,
  error,
  className = '',
  rows = 4,
  ...props
}) => {
  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label}
        </label>
      )}
      <div className="relative">
        <textarea
          rows={rows}
          className={`block w-full rounded-lg border ${
            error
              ? 'border-red-500 focus:ring-red-500 focus:border-red-500'
              : 'border-gray-300 focus:ring-primary-500 focus:border-primary-500'
          } px-4 py-2.5 text-sm focus:outline-none focus:ring-2 transition-colors duration-200 ${
            props.disabled ? 'bg-gray-100 cursor-not-allowed opacity-60' : 'bg-white'
          }`}
          {...props}
        />
      </div>
      {error && <p className="mt-1.5 text-sm text-red-600">{error}</p>}
    </div>
  );
};

export default Textarea;
